// ══════════════════════════════════════════════════════════════
// COMPASS – Process Observation Model
// ══════════════════════════════════════════════════════════════

/**
 * The Compliance Officer's free texts on a process (the backend's KycProcessObservation): each kept on its own
 * endpoint, apart from the form, and printed in the KYC report. Source of Funds observations (US-005), Geographic Risk
 * Analysis and Final Observations (US-009).
 */
export type ProcessObservationKind = 'sourceOfFunds' | 'geographicRiskAnalysis' | 'finalObservations';

/** Each one's i18n group: its texts are `PROCESS.<group>.*`, its errors `PROCESS.ERROR.LOAD_<group>` and `SAVE_<group>`. */
export const PROCESS_OBSERVATION_I18N: Record<ProcessObservationKind, string> = {
  sourceOfFunds: 'SOURCE_OF_FUNDS_OBSERVATIONS',
  geographicRiskAnalysis: 'GEOGRAPHIC_RISK_ANALYSIS',
  finalObservations: 'FINAL_OBSERVATIONS',
};

/** KycProcessObservation.MAX_LENGTH on the backend, the same for all of them. */
export const PROCESS_OBSERVATION_MAX_LENGTH = 4000;
